import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const translationCoverageDataSchema = z.object({
  totalPublished: z.number(),
  byLang: z.array(
    z.object({
      lang: z.string(),
      translated: z.number(),
    }),
  ),
});

export type IGetTranslationCoverageV1Data = z.infer<typeof translationCoverageDataSchema>;

export const getTranslationCoverageV1ResponseSchema = createApiResponseSchema(
  translationCoverageDataSchema,
) as z.ZodSchema<IAPI<IGetTranslationCoverageV1Data>>;

export type IGetTranslationCoverageV1Response = IAPI<IGetTranslationCoverageV1Data>;
